import { useNavigate } from 'react-router-dom';

export default function AnaSayfa() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
      <h1 style={{ color: '#1e2a3a' }}>RestMenu</h1>
      <p style={{ color: '#6b7684', maxWidth: 420, textAlign: 'center' }}>
        Restoranlar için QR menü sistemi. Tanıtım, fiyatlar ve avantajlar burada yer alacak.
      </p>
      <button onClick={() => navigate('/admin/login')} className="btn btn-vurgu">Yönetim</button>
    </div>
  );
}
